import { render, staticRenderFns } from "./UpdateCardsDialog.vue?vue&type=template&id=19272d02&scoped=true"
import script from "./UpdateCardsDialog.vue?vue&type=script&lang=js"
export * from "./UpdateCardsDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateCardsDialog.vue?vue&type=style&index=0&id=19272d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19272d02",
  null
  
)

export default component.exports